module.exports = __webpack_public_path__ + "img/garage.8ea97ce0.jpg";